import { render, staticRenderFns } from "./PencetakNonTeks.vue?vue&type=template&id=6a5d6bb6&scoped=true"
import script from "./PencetakNonTeks.vue?vue&type=script&lang=js"
export * from "./PencetakNonTeks.vue?vue&type=script&lang=js"
import style0 from "./PencetakNonTeks.vue?vue&type=style&index=0&id=6a5d6bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d6bb6",
  null
  
)

export default component.exports